import type { ReactElement } from "react";
import { useMemo } from "react";

import type { CheckboxFilterModel } from "../../../models/CheckboxFilterModel";
import type { IFilterViewBaseProps } from "../../../types/filterInstance";
import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel/components/FiltersChip/FiltersChip";

import { StyledCheckboxFilterResultContainer } from "./styles";
import type { ICheckboxFilterOption } from "./types";

export const CheckboxFilterResult = <T extends string = string>({
    value,
    filter,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
}: IFilterViewBaseProps<CheckboxFilterModel<T>>): ReactElement | null => {
    const handleRemove = (id: T): void => {
        const updatedValues = value?.filter((v: T) => v !== id);
        onFilterUpdate(updatedValues);
    };

    const options: ICheckboxFilterOption<T>[] = useMemo(() => {
        if (!value || value.length === 0) {
            return [];
        }

        return filter.options.filter((option: ICheckboxFilterOption<T>) => value.includes(option.value));
    }, [value]);

    if (!value?.length) {
        return null;
    }

    return (
        <StyledCheckboxFilterResultContainer>
            {options.map((item: ICheckboxFilterOption<T>) => {
                const valueLifecycleStatus = onGetLifecycleStatus?.(item.value);

                return (
                    <FiltersChip
                        text={item.label}
                        chipStatus={valueLifecycleStatus}
                        hideActionButton={!isActionEnabled}
                        onClose={() => handleRemove(item.value)}
                    />
                );
            })}
        </StyledCheckboxFilterResultContainer>
    );
};
